export function extractTitle(text: string | null | undefined) {
  if (typeof text !== 'string') return null;
  const lines = text.split('\n');

  const titleLine = lines.find(
    (line) =>
      line.includes('**Title:') ||
      line.includes('**Title**') ||
      line.match(/\*\*Title\*\*/) ||
      line.match(/\*\*Title\b/),
  );

  if (!titleLine) {
    return null;
  }

  if (titleLine.includes('**Title**: ')) {
    return titleLine.split('**Title**: ')[1].trim();
  } else if (titleLine.includes('**Title:**')) {
    return titleLine.split('**Title:**')[1].trim();
  } else if (titleLine.includes('**Title: ')) {
    return titleLine.split('**Title: ')[1].trim();
  } else if (titleLine.includes('**Title:')) {
    const match = titleLine.match(/\*\*Title:\s*(.*?)(?:\*\*)?$/);
    return match ? match[1].trim() : null;
  } else if (titleLine.includes('**Title**')) {
    return titleLine.replace('**Title**', '').trim();
  } else if (titleLine.match(/\*\*Title\b/)) {
    return titleLine
      .replace(/\*\*Title\b\s*/, '')
      .replace(/\*\*$/, '')
      .trim();
  }

  return null;
}
